// Input sanitization utilities
/* eslint-disable no-control-regex */
/* eslint-disable no-useless-escape */

export const sanitizeText = (text) => {
  if (!text) return text;
  
  // Remove HTML/script tags
  text = text.replace(/<[^>]*>/g, '');
  
  // Remove control characters except newlines
  text = text.replace(/[^\x20-\x7E\n]/g, '');
  
  // Convert multiple spaces to single space but preserve newlines
  //text = text.replace(/\s+/g, ' ');
  
  return text; // don't trim as you can never add a trailing space
};

export const sanitizeFilename = (filename) => {
  if (!filename) return filename;
  
  // Remove any path traversal attempts
  filename = filename.replace(/^.*[/\\]/g, '');
  
  // Remove any non-alphanumeric characters except .-_
  return filename.replace(/[^a-zA-Z0-9._-]/g, '');
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    throw new Error('Invalid email format');
  }
  return email.toLowerCase();
};

export const sanitizePhone = (phone) => {
  if (!phone) return phone;
  
  // Remove all non-numeric characters
  phone = phone.replace(/\D/g, '');
  
  if (phone.length < 10 || phone.length > 15) {
    throw new Error('Phone number must be between 10 and 15 digits');
  }
  
  return phone;
};
